import { render } from "./SuggestCaptionDialog.vue?vue&type=template&id=bd1d9302&scoped=true&ts=true"
import script from "./SuggestCaptionDialog.vue?vue&type=script&lang=ts"
export * from "./SuggestCaptionDialog.vue?vue&type=script&lang=ts"

import "./SuggestCaptionDialog.vue?vue&type=style&index=0&id=bd1d9302&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1d9302"]])

export default __exports__